import { useAuth } from '@multiplatform-apps/service-trips';
import { FC } from 'react';

import { useDeviceType } from '../../../hooks';
import { MenuAuthItems } from './menu-auth-items';
import { MenuFooter } from './menu-footer';
import { MenuHeader } from './menu-header';
import { StyledLinksContainer, StyledMenu } from './styles';
import { MenuProps } from './types';

export const Menu: FC<MenuProps> = ({ closeMenu }) => {
  const { isAuthenticated } = useAuth();
  const deviceType = useDeviceType();

  return (
    <StyledMenu isMobile={deviceType === 'mobile'}>
      <MenuHeader />
      <StyledLinksContainer>
        {isAuthenticated && <MenuAuthItems closeMenu={closeMenu} />}
        <MenuFooter closeMenu={closeMenu} />
      </StyledLinksContainer>
    </StyledMenu>
  );
};
